var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11.9994 14.6C11.7008 14.6 11.4477 14.3804 11.4054 14.0848L10.4054 7.08485C10.3809 6.91266 10.4322 6.73827 10.5461 6.60687C10.6601 6.47547 10.8255 6.39999 10.9994 6.39999H12.9994C13.1734 6.39999 13.3387 6.47547 13.4527 6.60687C13.5667 6.73827 13.618 6.91266 13.5934 7.08485L12.5934 14.0848C12.5512 14.3804 12.298 14.6 11.9994 14.6ZM11.3 16.5C11.3 16.1134 11.6134 15.8 12 15.8C12.3866 15.8 12.7 16.1134 12.7 16.5C12.7 16.8866 12.3866 17.2 12 17.2C11.6134 17.2 11.3 16.8866 11.3 16.5Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.cd66239b40e58226ff41ab854944d535.svg";
export { ForwardRef as ReactComponent };